import { render, staticRenderFns } from "./NoviceGuideCards.vue?vue&type=template&id=0eb6d2f9&scoped=true&"
import script from "./NoviceGuideCards.vue?vue&type=script&lang=ts&"
export * from "./NoviceGuideCards.vue?vue&type=script&lang=ts&"
import style0 from "./NoviceGuideCards.vue?vue&type=style&index=0&id=0eb6d2f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb6d2f9",
  null
  
)

export default component.exports